import { goSolidApi } from "@/composables/useGoSolidApi";
import type {
  LedgerEntry,
  LedgerEntrySources,
  LedgerOverview,
} from "./ledgerTypes";

const BASE = "/api/admin/money/ledger";

/** Read-only admin ledger routes (SALES_READ). An unknown company or entry answers 404. */
export const ledgerApi = {
  getOverview: (companyId: number) =>
    goSolidApi.get<LedgerOverview>(`${BASE}/companies/${companyId}`),
  listEntries: (companyId: number) =>
    goSolidApi.get<{ entries: LedgerEntry[] }>(
      `${BASE}/companies/${companyId}/entries`
    ),
  getEntrySources: (entryId: number) =>
    goSolidApi.get<LedgerEntrySources>(`${BASE}/entries/${entryId}/sources`),
};
